'use strict';

var App = require('app');
var AppState = require('app_state');
var Misc = require('utils/misc');
var Utils = require('models/utils');

function getDeviceRankingURL(filterData) {
    var url = '/api/v1/devices/ranking';
    var urlParts = [];

    if (filterData.sortCol) urlParts.push('sort_col=' + filterData.sortCol);
    if (filterData.sortDesc) urlParts.push('sort_desc=1');
    if (filterData.offset > 0) urlParts.push('offset=' + filterData.offset);
    if (filterData.limit > 0) urlParts.push('limit=' + filterData.limit);
    if (filterData.priority > 0) urlParts.push('priority=' + filterData.priority);
    if (filterData.category) urlParts.push('category=' + filterData.category);
    if (filterData.rule) urlParts.push('rules=' + filterData.rule.join(','));
    if (filterData.filter) urlParts.push('filter=' + JSON.stringify(filterData.filter));

    if (urlParts.length > 0) {
        url += '?' + urlParts.join('&');
    }
    return url;
}

var attachDeviceInfo = function (model, fctContinue) {
    // get additional columns that need to be listed
    var additionalCols = Misc.selectWhere(AppState.selectedColumns('ranking'), function (x) {
        return !x.alwaysVisible;
    });

    // get device list
    var models = model.get('items');
    var deviceList = Misc.selectWhere(
        models,
        undefined,
        function (x) {
            return x.device_id;
        },
        true
    );

    if (deviceList.length == 0) {
        fctContinue(model);
        return;
    }

    var req = App.request('device:list', {
        filter: { devices: deviceList },
        wantAll: true,
    });

    $.when(req).done(function (devList) {
        _.each(models, function (m) {
            _.each(devList.items.models, function (dm) {
                if (dm.id != m.device_id) return;
                _.each(dm.attributes, function (value, key) {
                    if (key != 'id') {
                        m[key] = value;
                    }
                });
            });
        });

        fctContinue(model);
    });
};

var DeviceRankingResult = Backbone.Model.extend({
    url: function () {
        return getDeviceRankingURL(this.get('source'));
    },

    setPage: function (page, itemsPerPage, sortCol, sortDesc, onComplete) {
        var filterData = this.get('source');

        filterData.page = page;
        filterData.limit = itemsPerPage;
        filterData.offset = (page - 1) * itemsPerPage;
        filterData.sortCol = sortCol;
        filterData.sortDesc = sortDesc;

        filterData.onUpdate();

        var self = this;
        this.fetch({
            success: function () {
                if (onComplete) {
                    attachDeviceInfo(self, function (r) {
                        onComplete(new DeviceRanking(r.get('items')), r.get('count'));
                    });
                }
            },
        });
    },
});

var DeviceRankingItem = Backbone.Model.extend({
    defaults: {
        modelType: 'ranking',
    },
    initialize: function () {
        Backbone.Select.Me.applyTo(this);
    },
});

var DeviceRanking = Backbone.Collection.extend({
    model: DeviceRankingItem,
    urlRoot: '/api/v1/devices/ranking',
    initialize: function (options) {
        Utils.SelectableCollection.applyTo(this, options);
    },
});

var API = {
    calculateStatistics: function (data, selection, refresh) {
        var series = _.map(data.series, function (item) {
            return item.value;
        });
        var defer = $.Deferred();
        App.ajax({
            method: 'POST',
            url: '/api/v1/devices/statistics',
            data: JSON.stringify({
                filter: data.filter,
                series: series,
                selection: selection,
                refresh: refresh,
            }),
            success: function (resultData) {
                _.each(data.series, function (item, idx) {
                    var r = resultData[item.value];
                    item.result = r;
                    item.idx = idx;
                });

                defer.resolve(true);
            },
            error: function (err) {
                defer.resolve(false);
            },
        });

        return defer.promise();
    },

    getRankingRules: function () {
        return Misc.deferredFct(function (defer) {
            App.ajax({
                method: 'GET',
                url: '/api/v1/devices/ranking/rules',
                success: function (resultData) {
                    defer.resolve(resultData);
                },
                error: function (err) {
                    defer.resolve(undefined, err);
                },
            });
        });
    },

    getDevicesRanking: function (filterData) {
        return Misc.deferredFct(function (defer) {
            var url = getDeviceRankingURL(filterData);

            App.ajax({
                method: 'GET',
                url: url,
                success: function (resultData) {
                    var model = new DeviceRankingResult(resultData);
                    model.set('source', filterData);
                    attachDeviceInfo(model, function (m) {
                        defer.resolve(m);
                    });
                },

                error: function (err) {
                    defer.resolve(undefined, err);
                },
            });
        });
    },

    hideRankingDevices: function (devices) {
        return Misc.deferredFct(function (defer) {
            App.ajax({
                method: 'POST',
                url: '/api/v1/devices/ranking/remove',
                data: JSON.stringify({
                    list: devices,
                }),
                success: function () {
                    defer.resolve(true);
                },
                error: function () {
                    defer.resolve(undefined);
                },
            });
        });
    },

    showAllRankingDevices: function (devices) {
        return Misc.deferredFct(function (defer) {
            App.ajax({
                method: 'DELETE',
                url: '/api/v1/devices/ranking/remove',
                success: function () {
                    defer.resolve(true);
                },
                error: function () {
                    defer.resolve(undefined);
                },
            });
        });
    },
};

App.reqres.setHandler('statistics:calculate', function (data, selection, refresh) {
    return API.calculateStatistics(data, selection, refresh);
});

App.reqres.setHandler('ranking:rules', function () {
    return API.getRankingRules();
});

App.reqres.setHandler('ranking:devices', function (filterData) {
    return API.getDevicesRanking(filterData);
});

App.reqres.setHandler('ranking:devices:hide', function (devices) {
    return API.hideRankingDevices(devices);
});

App.reqres.setHandler('ranking:devices:show:all', function (devices) {
    return API.showAllRankingDevices(devices);
});

module.exports = {
    Ranking: { Collection: DeviceRanking },
};
